<template>
  <div>
    <px-view-header title="Detalhes da cotação" :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary"
               @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>
    <div v-if="loading">
      <px-circular-loading/>
    </div>

    <div v-if="!loading && resposta">
      <px-resposta-cotacao-frete-detalhes-basico :resposta="resposta"
                                                 :cotacao="cotacao"/>
      <px-resposta-cotacao-frete-tabs class="mt-3"
                                      :resposta="resposta"
                                      :cotacao="cotacao"/>
    </div>
  </div>
</template>

<script>
import RespostaFreteService from '../resposta-frete-service';
import RespostaCotacaoFreteDetalhesBasico from './RespostaCotacaoFreteDetalhesBasico.vue';
import RespostaCotacaoFreteTabs from './RespostaCotacaoFreteTabs.vue';
import CotacaoFreteService from '../../../cotacao-frete-service';

export default {
  data() {
    return {
      id: this.$route.params.id,
      idResposta: this.$route.params.idResposta,
      resposta: null,
      cotacao: null,
      loading: false,
      breadcrumbs: [
        { text: 'Gestão de frete' },
        {
          text: 'Cotações de frete',
          to: '/cotacoes-fretes',
        },
        { text: 'Detalhes da resposta' },
      ],
    };
  },
  methods: {
    onClickBack() {
      this.$router.push({
        name: 'main.gestao-frete.cotacoes.detalhes',
        params: {
          id: this.id,
        },
      });
    },
    getResposta() {
      this.loading = true;
      RespostaFreteService.getResposta(this.id, this.idResposta)
        .then((resposta) => {
          this.resposta = resposta.data;
          return this.getCotacao();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCotacao() {
      return CotacaoFreteService.getCotacao(this.id)
        .then(({ data }) => {
          this.cotacao = data;
        });
    },
  },
  created() {
    this.getResposta();
  },
  components: {
    pxRespostaCotacaoFreteDetalhesBasico: RespostaCotacaoFreteDetalhesBasico,
    pxRespostaCotacaoFreteTabs: RespostaCotacaoFreteTabs,
  },
};
</script>
